define("Ames.PriorityBrandSort.PriorityBrandSort", [
  "SC.Configuration",
  "Facets.Browse.View",
], function (Configuration, FacetsBrowseView) {
  "use strict";
  var PRIORITY_SORT = "custitem_priority_brand:desc,relevance:desc";

  _.extend(FacetsBrowseView.prototype, {
    initialize: _.wrap(FacetsBrowseView.prototype.initialize, function (fn) {
      // Run the original initialize first — it builds this.translator,
      // this.isCategoryPage and this.model.options.data
      var ret = fn.apply(this, _.toArray(arguments).slice(1));

      var keywords = this.translator.getOptionValue("keywords");
      var userSelectedOrder = this.translator.getOptionValue("order");
      var isDefaultOrder =
        !userSelectedOrder ||
        userSelectedOrder === "relevance:asc" ||
        userSelectedOrder === "relevance:desc";

      // Only for free-text searches (not category PLPs),
      // and only when the user hasn't explicitly picked another sort
      if (!this.isCategoryPage && keywords && isDefaultOrder) {
        this.model.options.data.sort = PRIORITY_SORT;
      }

      return ret;
    }),
  });
  return {
    mountToApp: function mountToApp(container) {},
  };
});
